export const PROFILE_BUILDER_STEPS = {
  WELCOME: 'welcome',
  PROFESSION: 'profession',
  LOCATION: 'location',
  INSTITUTION: 'institution',
  GRADES: 'grades',
  SUBJECTS: 'subjects',
  NAME: 'name',
  BEST_PRACTICES: 'best-practices',
};

const stepOptions = Object.values(PROFILE_BUILDER_STEPS);

export type StepVariant = (typeof stepOptions)[number];
